<template>
  <div class="m-provenance-list">
    <div class="visually-hidden hidden-media-print-visible">
      <h3>
        {{ printHeading }}
      </h3>
      <h4 id="provenance-list-aria">
        {{ ariaHeading }}
      </h4>
      <br />
    </div>
    <ul class="m-provenance-list__list" aria-labelledby="provenance-list-aria">
      <li v-for="(item, index) of provenanceInfo.data" :key="index">
        <ProvenanceItem v-bind="item" />
      </li>
    </ul>

    <div
      v-if="provenanceInfo.notes.length"
      ref="remarks"
      class="m-provenance-list__notes"
    >
      <h4 class="m-provenance-list__notes_heading">
        {{ overallProvenanceNotesHeading }}
      </h4>
      <RichText
        v-for="(provenanceNote, index) of provenanceInfo.notes"
        :key="'note-' + index"
        class="m-provenance-list__notes_note"
        :content="provenanceNote"
      />
    </div>
  </div>
</template>
<script>
import ProvenanceItem from "@/components/atoms/provenanceItem/index.vue";
import { useLocalization } from "@thegetty-private/getty-ui";
import { RichText } from "@thegetty-private/getty-ui";
export default {
  name: "ProvenanceList",
  components: { ProvenanceItem, RichText },

  props: {
    /**
     * the Provenance information from the store
     */
    provenanceInfo: {
      type: Object,
      required: true,
      default: () => {
        return { data: [], notes: [] };
      }
    },
    /**
     * the indexed id of the object
     */
    indexedId: {
      type: String,
      required: true
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },
  data() {
    return {
      /**
       * The ARIA heading for the provenance data
       */
      ariaHeading: this.translatePart("provenance_list.ariaHeading"),
      /**
       * The heading for the provenance notes section
       */
      overallProvenanceNotesHeading: this.translatePart(
        "provenance_list.noteHeading"
      ),
      /**
       * The heading displayed on just the print style sheet
       */
      printHeading: this.translatePart(
        "human_made_object_tabs.provenanceTabName"
      ),
      /**
       * The text displayed for the provenance vizualization link
       */
      vizualizationText: this.translatePart(
        "human_made_object_tabs.provenanceVizualizationText"
      )
    };
  }
};
</script>
<style lang="scss">
@import "./index.scss";
</style>
